import { asyncRoutes } from "@/router";
import { resolve } from "core-js/fn/promise";
// process.env.NODE_ENV 全局NODE环境变量，当生产模式时也就是build 的时候 process.env.NODE_ENV = production
// 当开发模式时也就是serve 的时候 process.env.NODE_ENV = development
// 当build时node找到的是 => require('@/router/_import_production.js)
const _import = require("@/router/_import_" + process.env.NODE_ENV); //获取组件的方法
const state = {
  routes: [],
  addRoutes: [],
  searchRouters: []
};
// 处理功能菜单信息
//  遍历后台传来的路由字符串，转换为组件对象
function filterAsyncRouter(asyncRouterMap, savePathList) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      //  Layout组件特殊处理
      try {
      if (route.component) {
          // route.component = _import(route.component);
          const { path } = handleRoutePath(route, savePathList);
          savePathList.push(path);
        } else {
          route.component = () => import("@/views/error/error");          
        }
      }catch (error) {
        route.component = () => import("@/views/error/error");
        console.error(route.name, "页面未找到");
      }
    }
    if (route.children && route.children.length) {
      route.children = filterAsyncRouter(route.children, savePathList);
    } else {
      route.children = [];
    }
    return true;
  });
  return accessedRouters;

  // 处理路由路径
  function handleRoutePath(routePath, savePathList) {
    routePath.href = routePath.coustomParameters;
    const isHttp = (routePath.path && routePath.path.includes("http")) || false;
    const component = routePath.component;
    const path = routePath.path;
    routePath.saveComponent = component;
    routePath.savePath = path;
    routePath.path = !isHttp
      ? "/" + handlePath(component)
      : "" + handlePath(component);
    if (!isHttp) {
      routePath.component = _import(
        handlePath(routePath.component, ["src", "views"])
      );
    } else {
      routePath.component = _import(handlePath("emptyComponent/index"));
    }
    // 路由去重
    let index = 0;
    do {
      index = savePathList.findIndex(item => item == routePath.path);
      if (index > -1) {
        routePath.path = routePath.path + "s";
      }
    } while (index > -1);
    return routePath;
    function handlePath(component, arr = ["src", "index", "views"]) {
      return component
        .split("/")
        .filter(i => !arr.includes(i))
        .join("/");
    }
  }
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes;
    state.routes = asyncRoutes.concat(routes);
  },
  SET_SEARCH_ROUTES: (state, routes) => {
    state.searchRouters = routes.map(i => ({
      ...i,
      children: [],
      component: {}
    }));
  }
};

const actions = {
  // 处理后台返回的功能菜单 并生成路由
  generateRoutes({ commit }, funcs) {
    let accessedRoutes = [],
      handleRoutes = [];
    return new Promise(resolve => {
      try {
        let savePathList = [];
        accessedRoutes = filterAsyncRouter(funcs, savePathList);
        savePathList = null;
        handleRoutes = recursionGetRouterPath(accessedRoutes, 1);
        commit("SET_ROUTES", accessedRoutes);
        commit("SET_SEARCH_ROUTES", handleRoutes);
        resolve(handleRoutes);
      } catch (e) {
        resolve(handleRoutes);
      }
    });
    function recursionGetRouterPath(routerList, level) {
      let result = [];
      routerList.forEach(item => {
        item.name = item.path.replace('/', '')
        if (
          (item.path &&
            item.component &&
            typeof item.component == "function") ||
          (item.path && item.component && typeof item.component == "object")
        ) {
          result.push({ ...item, children: [], level });
        }
        if (item.children && item.children.length > 0) {
          const childList = recursionGetRouterPath(item.children, level + 1);
          result = [...result, ...childList];
        }
      });
      return result;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
